import { render, staticRenderFns } from "./AddPolicyModal.vue?vue&type=template&id=26e9c326&scoped=true&"
import script from "./AddPolicyModal.vue?vue&type=script&lang=js&"
export * from "./AddPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPolicyModal.vue?vue&type=style&index=0&id=26e9c326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e9c326",
  null
  
)

export default component.exports